import { Box, styled } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

export const BoxContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
});

export const RowNoData = styled('div')({
    fontSize: 20,
    margin: 'auto',
});

export const DateTimePickerArrival = styled(DateTimePicker)({
    '& .MuiInputLabel-shrink': { transform: 'translate(12px, -9px) scale(0.75)', top: 0 },
    '& .MuiInputLabel-outlined': { transform: 'translate(14px, -9px) scale(0.75)', top: 0 },
    '& .MuiInputLabel-root': { backgroundColor: 'white', paddingLeft: '2px', paddingRight: '2px' },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        backgroundColor: 'white',
        paddingLeft: '2px',
        paddingRight: '2px',
        transform: 'translate(14px, -9px) scale(0.75)',
    },
});
